<template>
  <analytics-sub-page
    title="Loans Analytics"
    icon="hand-holding-dollar"
    css-class="analytics-loans"
    default-label="Loans"
    :section-specs="sectionSpecs"
  >
    <sdl-metrics ref="sdlRef" />
  </analytics-sub-page>
</template>

<script setup>
import { ref } from 'vue';
import AnalyticsSubPage from '@/components/AnalyticsSubPage.vue';
import SdlMetrics from '@/pages/analyticsApp/components/SdlMetrics.vue';

const sdlRef = ref(null);

const sectionSpecs = [{ key: 'loans', label: 'Loans', ref: sdlRef }];
</script>
